import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { TrackSsncComponent } from './track-ssnc/track-ssnc.component';
import { SessionGuard } from './services/guards/session-guard.service';
import { MasRetailLoginComponent } from './mas-retail-login/mas-retail-login.component';
import { ForgotPasswordComponent } from './mas-retail-login/forgot-password/forgot-password.component';
import { ContactUsComponent } from 'projects/nfrp-mas-retail-private-angular/src/nfrp-mas-retail/components/contact-us/contact-us.component';

const routes: Routes = [
  {
    path: 'login',
    component: MasRetailLoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'contact-us',
    component: ContactUsComponent
  },
  {
    path: 'privacy-policy',
    loadChildren: () =>
      import('projects/nfrp-mas-retail-private-angular/src/nfrp-mas-retail/components/privacy-policy/privacy-policy.module').then(
        (m) => m.PrivacyPolicyModule
      ),
  },
  {
    path: '',
    loadChildren: () => import('./layout/layout.module').then((m) => m.LayoutModule),
    canActivate: [SessionGuard],
    data: {
      breadcrumb: 'Mas Retail Private',
    },
  },
  {
    path: 'trac/ssnc',
    component: TrackSsncComponent,
    canActivate: [SessionGuard],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: "reload"})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
